import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Elements, injectStripe, StripeProvider } from 'react-stripe-elements';
import { AppConfig } from '../../../../config/app';
import { DataApi } from '../../../../providers/api-provider';
import GlobalStore from '../../../../providers/global-store-provider';
import { calculateTotalFees, handleInputState, handleResponseErrors, postMessageToParent, showError, showSuccess, track } from '../../libs/helpers';
import FundStudentSeedAmount from './FundStudentSeedAmount';
import FundStudentSeedPersonal from './FundStudentSeedPersonal';

class FundStudentSeedForm extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  state = {
    stepExpanded: 'chooseAmount',
    hearFromFunds: [],
    cardBrand: 'visa',
    cardComplete: false,
    loading: false,
    form: {
      fullAmount: false,
      buttonAmount: 500,
      anonymous: false,
      donorAlias: this.props.match.params.name || '',
      showDonorEmail: false,
      donorCoverFees: true,
      amount: '',
      processedAmount: '',
      paymentMethod: null,
      donorEmail: this.props.match.params.email || '',
      hearFromFundId: 'other',
      donorLike: 1,
      donorComment: '',
      dedicateMyDonation: false,
      inHonorOf: true,
      honoreeName: '',
      recipientEmail: '',
      recipientName: '',
      recipientMessage: '',
      recaptcha: '',
    },
  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /* API Call
  */
  performSeedAction = async (paymentMethod, name, email, paymentIntent) => {
    let form = { ...this.state.form };
    //Required after authorizing payments by donor (3d Secure)
    if (paymentIntent)
      form.paymentIntent = paymentIntent;
    //
    if (name && email) {
      form.donorAlias = name;
      form.donorEmail = email;
    } else if (!this.validateInformation())
      return false;
    try {
      track(this.props.trackPageCode, 'Donation Button Clicked');
      this.setState({ loading: true });
      if (!paymentMethod) {
        const paymentMethodRes = await this.props.stripe.createPaymentMethod('card');
        if (paymentMethodRes.error) {
          showError(paymentMethodRes.error.message);
          this.setState({ loading: false });
          track(this.props.trackPageCode, 'Donation Failed', paymentMethodRes.error.message);
          postMessageToParent('donation_error', {
            title: this.props.trackPageCode,
            message: paymentMethodRes.error.message,
          });
          return false;
        }
        paymentMethod = paymentMethodRes.paymentMethod;
      }
      form.paymentMethod = paymentMethod.id;
      if (form.buttonAmount)
        form.amount = form.buttonAmount;
      if (this.props.recaptchaEnabled)
        form.recaptcha = await this.props.recaptchaRef.current.executeAsync();
      form.allocateTo = this.props.fundraise.campaign.id;
      let donationRes = await DataApi.update('donor/fundraises/' + this.props.match.params.slug + '/seed-anonymous', form, {
        'Authorization': "Bearer " + this.props.match.params.token
      });
      //Show SnackBar
      showSuccess('Donation Completed, Thank you!', 'success');
      //
      track(this.props.trackPageCode, 'Donation Succeeded');
      this.setState({ loading: false, form: { ...form } });
      this.props.onDonationComplete(form.processedAmount, donationRes.data.online_donation.id);
      return true;
    }
    catch (error) {
      if (this.props.recaptchaRef && this.props.recaptchaRef.current) {
        this.props.recaptchaRef.current.reset();
      }
      const errorRes = error.response.data;
      //Check for required actions
      if (errorRes.requires_action) {
        const actionRes = await this.props.stripe.confirmCardPayment(errorRes.payment_intent.client_secret, {
          payment_method: form.paymentMethod,
        });
        if (actionRes.paymentIntent && actionRes.paymentIntent.status === "succeeded") {
          this.performSeedAction(paymentMethod, form.donorAlias, form.donorEmail, actionRes.paymentIntent.id)
          return;
        }
      }
      let newState = this.state;
      //Show SnackBar
      const message = showError(error);
      newState.errors = handleResponseErrors(error, this.state.errors);
      newState.loading = false;
      this.setState(newState);
      track(this.props.trackPageCode, 'Donation Failed', message);
    }
    return false;
  }

  async componentDidMount() {
    let form = this.state.form;
    if (this.props.match.params.amount) {
      form.amount = this.props.match.params.amount
    }
    if (GlobalStore.state.auth.loggedIn && !form.donorEmail) {
      form.donorEmail = GlobalStore.state.auth.user.email;
      form.donorAlias = GlobalStore.state.auth.user.name;
    }
    this.setState({ form }, () => this.onChangeAmount(this.state.form));
    track(this.props.trackPageCode, 'Checkout Loaded');
  }
  componentDidUpdate(prevProps) {
    if (this.props.instantDonate && !prevProps.instantDonate)
      this.performSeedAction(this.props.instantDonate);
  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  onPanelExpanded = (step) => {
    return () => {
      let steps = { donorInformation: 'Donor Information', chooseAmount: 'Choose Amount', checkout: 'Card Information', moreInformation: 'Give More' }
      this.setState({ 'stepExpanded': this.state.stepExpanded === step ? '' : step });
      track(this.props.trackPageCode, steps[step] + ' Opened');
    }
  }
  onFieldBlur = (field) => {
    return async (e) => {
      track(
        this.props.trackPageCode,
        field + (e.target.type !== "checkbox" ? ' Filled' : ''),
        e.target.type === "checkbox"
          ? (e.target.checked ? 'Checked' : 'Not Checked')
          : e.target.value);
    }
  }

  /* Validate Form */
  validateInformation = () => {
    if (!this.state.form.processedAmount) {
      showError('Fill out the amount please');
      this.onPanelExpanded('chooseAmount')();
      return false;
    }
    if (!this.state.form.donorEmail) {
      showError('Email is mandatory');
      return false;
    }
    if (!this.state.form.donorAlias) {
      showError('Name is mandatory');
      return false;
    }
    /*  if (this.state.form.dedicateMyDonation) {
       if (!this.state.form.honoreeName) {
         showError('Honoree Name is mandatory');
         this.onPanelExpanded('chooseAmount')();
         return false;
       }
       if (!this.state.form.recipientEmail) {
         showError('Recipient Email is mandatory');
         this.onPanelExpanded('chooseAmount')();
         return false;
       }
     } */
    return true;
  }
  /* Hanle State Management of form */
  onChange = handleInputState
  onChangeRoot = (newState, updateAmount) => {
    this.setState(newState);
    if (updateAmount && this.state.processedAmount)
      this.onChangeAmount(this.state.form);
  }
  onChangeForm = (key, value, updateAmount) => {
    //Multi Key Update
    if (typeof (key) === 'object') {
      this.setState({ form: { ...this.state.form, ...key } },
        () => value && this.onChangeAmount(this.state.form)
      );
    }
    else
      //Single Key update
      this.setState({ form: { ...this.state.form, [key]: value } },
        () => updateAmount && this.onChangeAmount(this.state.form)
      );
  }

  onChangeAmount = (amountDetails) => {
    let processedAmount = parseFloat(amountDetails.amount) || '';
    if (amountDetails.buttonAmount)
      processedAmount = amountDetails.buttonAmount;
    if (amountDetails.fullAmount)
      processedAmount = this.props.fundraise.needed_donations;
    if (this.state.form.donorCoverFees) {
      processedAmount = calculateTotalFees(processedAmount, this.state.cardBrand === 'amex');
    }
    this.setState({ form: { ...this.state.form, ...amountDetails, processedAmount: processedAmount } });
  }

  /* Render Page */
  render() {
    const { stepExpanded, form, loading, } = this.state;
    let { fundraise, trackPageCode, classes } = this.props;
    return (
      <div className="fullwidth">
        {/*Intro One */}
        <div>
          <Typography className={classes.headerText}>
            {fundraise.name}
          </Typography>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.headerText}>
                Donate To {fundraise.campaign.student_short.name}
              </Typography>
            </Grid>

          </Grid>
          <div className={classes.headerBorder}>
            <div className={classes.headerMainBorder}></div>
          </div>
          {/* <div className={classes.fundraiseInformationWrapperName}>
                        <Typography variant="body1" className={classes.fundraiseName}>
                            {fundraise.name} fundraise
                        </Typography>
                        <Typography variant="body1" className={classes.fundraiseDonations}>
                            Collected ${formatCurrency(fundraise.total_donations)} of ${formatCurrency(fundraise.total_needs)}
                        </Typography>
                    </div> */}
        </div>
        {/*Step One */}
        <div className={stepExpanded === 'chooseAmount' ? classes['stepActive'] : classes['stepInactive']} >
          <FundStudentSeedAmount
            onFieldBlur={this.onFieldBlur}
            form={form}
            onChange={this.onChangeForm}
            onPanelExpanded={this.onPanelExpanded}
            trackPageCode={trackPageCode}
            classes={classes}
            fundraise={fundraise}
          />
        </div>
        {/*Step Two */}
        <div className={stepExpanded === 'donorInformation' ? classes['stepActive'] : classes['stepInactive']}>
          <FundStudentSeedPersonal
            onFieldBlur={this.onFieldBlur}
            form={form}
            onChange={this.onChangeForm}
            onChangeRoot={this.onChangeRoot}
            trackPageCode={trackPageCode}
            onPanelExpanded={this.onPanelExpanded}
            classes={classes}
            performSeedAction={this.performSeedAction}
            loading={loading}
            fundraise={fundraise}
            stripe={this.props.stripe}
          />
        </div>
      </div>
    );
  }
}

const FundStudentSeedFormWrapped = injectStripe(withRouter(FundStudentSeedForm));
const stripeKey = ['localhost:3000', 'localhost:81', 'staging-edp.edseed.me'].indexOf(window.location.host) !== -1
  ? AppConfig.stripeTest : AppConfig.stripe;
export default function (props) {
  return (<StripeProvider apiKey={stripeKey}>
    <Elements>
      <FundStudentSeedFormWrapped {...props} />
    </Elements>
  </StripeProvider>);

}